<template>
	<div class="flex column overview">
		<div class="flex overview-bar-title">
			<div class="flex-item grow overview-title">{{ timeRangeText }}{{ dataSourceText }}总数</div>
			<div class="flex-item grow overview-title">{{ timeRangeText }}{{ dataSourceText }}完成</div>
		</div>
		<div class="flex overview-bar-num">
			<div class="flex grow center">
				<div v-for="n in total.toFixed(0).split('')"
				    class="overview-card-num total">
					{{ n }}
				</div>
			</div>
			<div class="flex grow center">
				<div v-for="n in finished.toFixed(0).split('')"
				    class="overview-card-num finished">
					{{ n }}
				</div>
			</div>
		</div>
		<div class="flex grow center overview-bar-circle">
			<i-circle class="overview-circle"
				:size="size"
				:percent="percent"
			    :stroke-color="theme.osPrimaryColor"
			    :stroke-width="strokeWidth"
			    :trail-color="theme.osTrailColor"
			    :trail-width="strokeWidth">
				<div class="overview-title-sub">完成率</div>
				<div class="overview-title-main">{{ percent }}<span class="overview-title-sub">%</span></div>
			</i-circle>
		</div>
	</div>
</template>
<script>
import { Circle } from 'ivux'
import theme from '../components/theme'
import common from './common'

export default {
	name: "OrderOverview",

	mixins: [theme, common],

	components: {
		iCircle: Circle
	},

	props: {
		total: {
			type: Number,
			default: 0,
		},
		finished: {
			type: Number,
			default: 0,
		},
	},

	data(){
		return {
			size: this.dp2p(117),
			strokeWidth: this.dp2p(12),
		}
	},

	computed: {
		percent(){
			return this.total ? parseFloat((this.finished / this.total * 100).toFixed(0)) : 0
		},
	},

	mounted(){
		this.afterContainerResize(this.$el, (el, rect) => {
            this.fit()
        })
	},

	methods:{
		fit(){
			this.size = this.dp2p(117)
			this.strokeWidth = this.dp2p(12)
		},
	}
}
</script>
<style lang="less"
    scoped>
@import '../components/theme.less';

.overview{
	height: 100%;

	&-bar{
		&-title{
			padding-top: 34px;
		}

		&-num{
			margin-top: 20px;
		}
	}

	&-card-num{
		width: 36px;
		height: 60px;
		line-height: 60px;
		text-align: center;
		color: #fff;
		font-size: 32px;

		&.total{
			background: url('../images/number_bg01.png') no-repeat center;
			background-size: cover;
		}

		&.finished{
			background: url('../images/number_bg02.png') no-repeat center;
			background-size: cover;
		}
	}

	&-title{
		font-size: 18px;
		line-height: 18px;
		color: @os-primary-color;

		&-sub{
			font-size: 14px;
			color: @os-primary-color;
		}

		&-main{
			font-size: 26px;
			margin-top: 13px;
			color: @os-primary-color;
		}
	}
}
</style>